export default __webpack_public_path__ + "static/media/coffeeshop_1.55f753bc.png";